import { render, staticRenderFns } from "./RoomAmenities.vue?vue&type=template&id=dffcd152&"
import script from "./RoomAmenities.vue?vue&type=script&lang=js&"
export * from "./RoomAmenities.vue?vue&type=script&lang=js&"
import style0 from "./RoomAmenities.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports